import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { authApi } from '../api';
import { logout } from '../services/storage';
import { UserTypes } from '../store/user';
import { RoutesConstants } from '../routes/routesConstants';
import { useDispatch } from 'react-redux';
import { disconnectSignalRHub } from '../middlewares/signalRMiddleware';

export function useLogout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingLogout, setIsLoadingLogout] = useState<boolean>(false);

  async function onLogoutLocal() {
    await disconnectSignalRHub();
    logout();
    navigate(RoutesConstants.login);
    dispatch({ type: UserTypes.USER_ISLOGOUT });
  }

  async function onLogoutAsync() {
    setIsLoadingLogout(true);
    try {
      await Promise.allSettled([authApi.logout(), disconnectSignalRHub()]);
    } finally {
      await onLogoutLocal();
      setIsLoadingLogout(false);
    }
  }

  return {
    onLogoutAsync,
    onLogoutLocal,
    isLoadingLogout
  };
}

